import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faTimes } from "@fortawesome/free-solid-svg-icons";

/**
 * NotificationEmptyState Component
 *
 * Modern empty state for notifications with different variants
 */
const NotificationEmptyState = ({
  variant = "empty", // "empty" | "all-read" | "no-results"
  className = "",
  hasActiveFilters = false,
  onClearFilters = null,
}) => {
  const configs = {
    empty: {
      icon: faBell,
      iconColor: "text-gray-400",
      iconBg: "bg-gray-100",
      title: "No notifications yet",
      description: "When you get notifications, they'll show up here.",
    },
    "all-read": {
      icon: faBell,
      iconColor: "text-gray-400",
      iconBg: "bg-gray-100",
      title: "All caught up!",
      description: "No new notifications right now.",
    },
    "no-results": {
      icon: faBell,
      iconColor: "text-blue-400",
      iconBg: "bg-blue-100",
      title: "No matching notifications",
      description: hasActiveFilters
        ? "Try adjusting your filters to see more notifications."
        : "No notifications match your current criteria.",
    },
  };

  const config = configs[variant] || configs.empty;

  return (
    <div className={`text-center py-12 px-6 ${className}`}>
      <div
        className={`w-16 h-16 mx-auto mb-4 ${config.iconBg} rounded-2xl flex items-center justify-center`}
      >
        <FontAwesomeIcon
          icon={config.icon}
          className={`text-2xl ${config.iconColor}`}
        />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {config.title}
      </h3>
      <p className="text-gray-500 text-sm leading-relaxed max-w-sm mx-auto mb-4">
        {config.description}
      </p>

      {/* Clear Filters Button for no-results variant */}
      {variant === "no-results" && hasActiveFilters && onClearFilters && (
        <button
          onClick={onClearFilters}
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-deep-red bg-deep-red/10 hover:bg-deep-red/20 rounded-lg transition-colors duration-200"
        >
          <FontAwesomeIcon icon={faTimes} className="text-xs" />
          Clear Filters
        </button>
      )}
    </div>
  );
};

export default NotificationEmptyState;
